exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-list[data-v-9965c9e8]{cursor:pointer}", ""]);

// exports
